import apiHandler from 'api/handlers/apiHandler.ts';
import userEndpoints from 'api/rtk-endpoints/UserEndpoints.ts';
import { client } from 'api/baseApi.ts';

export const getUserProfile = async ({ dispatch }) => {
	const response = await apiHandler({
		endpoint: userEndpoints.endpoints.getUserProfile.initiate,
		dispatch,
	});
	return response?.data ?? {};
};

export const updateUserProfileService = async (data, { dispatch }) => {
	const updatedProfileData = {
		...(data.displayName && { name: data.displayName }),
		...(data.profileUrl && { image: data.profileUrl }),
		...(data.bio && { bio: data.bio }),
		...(data.username && { handle: data.username }),
		...(data.links && {
			links: {
				buy_me_coffee: data.links.buyMeCoffee,
				patreon: data.links.patreon,
				discord: data.links.discord,
				instagram: data.links.instagram,
				twitter: data.links.x,
				facebook: data.links.facebook,
				reddit: data.links.reddit,
				telegram: data.links.telegram,
				email: data.links.email,
				others_1: data.links.additionalLink,
				others_2: data.links.additionalLink2,
			},
		}),
	};
	const response = await apiHandler({
		endpoint: userEndpoints.endpoints.updateUserProfile(updatedProfileData).initiate,
		dispatch,
	});
	return response?.data ?? {};
};

export const updateUserNameService = async (data, { dispatch }) => {
	const request = {
		name: data.displayName,
	};
	const response = await apiHandler({
		endpoint: userEndpoints.endpoints.updateUserProfile(request).initiate,
		dispatch,
	});
	return response?.data ?? {};
};

export const signInService = async ({ authToken }) => {
	try {
		const response = await client.user.startSession(authToken);
		return { data: response.data };
	} catch (e) {
		if (e?.code !== 'ERR_CANCELED') throw e;
		throw new Error(e?.message);
	}
};

export const deleteAccount = async () => {
	try {
		const response = await client.user.delete();
		return { data: response.data };
	} catch (e) {
		if (e?.code !== 'ERR_CANCELED') throw e;
		throw new Error(e?.message);
	}
};
